import { Injectable } from "@angular/core";
import { GenericService } from "./generic.service";
import { NotificationsService } from "angular2-notifications";
import { CellVisitApi } from "../api/cell-visit.api";
import { ICellVisit } from "../model/cell-visit.model";
import { apiCallWrapper, createUrl } from "../api/api.util";

@Injectable()
export class CellVisitService extends GenericService<ICellVisit> {
  constructor(
    public cellVisitApi: CellVisitApi,
    public notifications: NotificationsService
  ) {
    super(cellVisitApi, notifications);
  }

  listingCellVisit(query: {
    page: number;
    limit: number;
    search: string;
    filter: Record<string, unknown>
  }) {
    return apiCallWrapper(
      this.cellVisitApi.listingCellVisit(query),
      {
        notificationsService: this.notifications,
        action: `Fetching Cell Visit Records`
      }
    );
  }

  // Admin-only: DELETE with reason in body
  deleteWithReason(id: string | number, reason: string) {
    const url = createUrl(this.cellVisitApi.path, id);
    return apiCallWrapper(
      this.cellVisitApi.httpClient.request<{ success: boolean; deleted?: number }>(
        'DELETE',
        url,
        { body: { reason } }
      ),
      {
        notificationsService: this.notifications,
        action: `Deleting cell visit ${id}`
      }
    );
  }

  // Admin-only: Fetch audit entries for a record
  getAudits(id: string | number) {
    // Backend route shape: GET /cell-visit/:id/audit
    const url = `${createUrl(this.cellVisitApi.path, id)}/audit`;
    return apiCallWrapper(
      this.cellVisitApi.httpClient.get<any>(url),
      {
        notificationsService: this.notifications,
        action: `Fetching Cell Visit Audit ${id}`,
        defaultValue: { items: [] }
      }
    );
  }
}